<app-cards>
  <app-card [selected]="value === 'myself'" (click)="setValue('myself')">
    <h2 class="h4 text-center text-uppercase" i18n="General|Myself label@@personMyselfLabel">Mezelf</h2>
  </app-card>
  <app-card [selected]="!!value && value !== 'myself'" (click)="openDialog()">
    <h2 class="h4 text-center text-uppercase" i18n="General|Someone else label@@personSomeoneElseLabel">Een ander</h2>
  </app-card>
</app-cards>
